$('.map-cards-slider').slick({
  slidesToShow: 3,
  slidesToScroll: 3,
  centerMode: true,
  variableWidth: true,
  infinite: false,
  nextArrow: '<button type="button" class="arrow-next"><i class="fa-solid fa-angle-right"></i></button>',
  prevArrow: '<button type="button" class="arrow-prev"><i class="fa-solid fa-angle-left"></i></button>',
  responsive: [
    {
      breakpoint: 1400,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        centerMode: true,
      },
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        centerMode: false,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
      },
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
      },
    },
  ],
});
